import {
  Box,
  Button,
  Grid,
  Link,
  SpaceBetween,
  FormField,
  Input,
  StatusIndicator,
  Checkbox,
  Form,
  Popover,
  Autosuggest,
  Alert,
  RadioGroup,
  Modal,
} from "@cloudscape-design/components";
import { useEffect, useState, useContext } from "react";
import { GlobalContext, ContentContext } from "../../../context";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { withAuthenticator, Authenticator } from '@aws-amplify/ui-react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { navigateFn } from "../../../routingHelper";
import useAxios, {
  configure,
  loadCache,
  serializeCache,
  makeUseAxios,
} from 'axios-hooks'
import { leagueId } from '../../../leagueId';
import { RotatingLines, ThreeDots, BallTriangle } from  'react-loader-spinner'
import * as awsui from "@cloudscape-design/design-tokens";
import usePlacesService from "react-google-autocomplete/lib/usePlacesAutocompleteService";
import DatePicker from '../../../components/date-picker/DatePicker';
import { useLocalStorage } from 'usehooks-ts';
import { CustomButton } from "../../../components/buttons";


const apiKey = "2ff73ab3016540b097d3c5cfed50f001f3fb1ce8cf144cc7a9282ee530bb5f2f";
const baseUrl = "https://formularacinggroup.au/api";
const axiosHeaders = { 
  "api-key": apiKey, 
  "Content-Type": "application/json",
}
const seriesId = "01H51VP9QX6TDT5W097GACKS33"


export default function Register() {
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  const location = useLocation();
  const { 
    theme, setTheme, 
    density, setDensity,
    seriesContent, setSeriesContent,
    userAttributes, setUserAttributes,
  } = useContext(GlobalContext);
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const { route } = useAuthenticator(context => [context.route]); 
  const { authStatus } = useAuthenticator(context => [context.authStatus]); 

  // const [ username, setUsername ] = useState<string>();
  const [ email, setEmail ] = useState<string>();
  const [ givenName, setGivenName ] = useState<string>();
  const [ familyName, setFamilyName ] = useState<string>();
  const [ name, setName ] = useState<string>();
  // const [ profilePicture, setProfilePicture ] = useState<string>();
  // const [ groups, setGroups ] = useState<string>();
  const [ dob, setDob ] = useState<string>();
  // const [ phone, setPhone ] = useState<string>();
  const [ address, setAddress ] = useState<string>();
  // const [ addressPlaceholder, setAddressPlaceholder ] = useState<string>();
  // const [ maLicenseId, setMaLicenseId ] = useState<number>();
  const [ driverId, setDriverId ] = useState<string>();
  const [ irUserId, setIrUserId ] = useState<number>();
  const [ irUserName, setIrUserName ] = useState<string>();
  const [ country, setCountry ] = useState<string>();
  const [ addressUrl, setAddressUrl ] = useState<string>();
  const [ state, setState ] = useState<string>();
  const [ postCode, setPostCode ] = useState<number>();
  // const [ discordId, setDiscordId ] = useState<string>();
  // const [ leagueCarNum, setLeagueCarNum ] = useState<string>("0");
  // const [ leagueSecondaryCarNum, setLeagueSecondaryCarNum ] = useState<string>("0");
  // const [ leagueTertiaryCarNum, setLeagueTertiaryCarNum ] = useState<string>("0");
  // const [ seriesCarNum, setSeriesCarNum ] = useState<string>();
  // const [ seriesSecondaryCarNum, setSeriesSecondaryCarNum ] = useState<string>();
  // const [ seriesTertiaryCarNum, setSeriesTertiaryCarNum ] = useState<string>();
  // const [ driverBio, setDriverBio ] = useState<string>();
  const [ agreeToSeriesRules, setAgreeToSeriesRules] = useState<boolean>(false);
  const [ agreeToFrgPrivayPolicy, setAgreeToFrgPrivayPolicy] = useState(false);
  const [ placeDetails, setPlaceDetails ] = useState<any>();
  const [ driverRegistered, setDriverRegistered ] = useState<boolean>();
  const [ submitError, setSubmitError ] = useState<boolean>();
  const {
    placesService,
    placePredictions,
    getPlacePredictions,
    isPlacePredictionsLoading,
  } = usePlacesService({
    apiKey: "AIzaSyAyAAyFRzCh2NkkvNlLEKmdWHZ1lenQ5nk",
  });
  const options = {
    fields: ["formatted_address", "geometry", "name"],
    strictBounds: false,
    types: ["establishment"],
  };


  useEffect(() => {
    if (placePredictions.length)
      placesService?.getDetails(
        {
          placeId: placePredictions[0].place_id,
        },
        (placeDetails: any) => {
          setPlaceDetails(placeDetails)
        }
      );
  }, [placePredictions]);

  // const axiosConfig = (url:string, method:string, params:{}) => {
  //   return {
  //     url: baseUrl + url,
  //     method: method,
  //     headers: axiosHeaders,
  //     params: params
  //   }
  // }

  // const [{ data: irDriverData, loading: irDriverLoading, error: irDriverError}, getIrDriver] = useAxios(axiosConfig(
  //     "/iracing_driver",
  //     "get",
  //     {
  //       irUserName: name
  //     }
  //   ), { 
  //   manual: true,
  // })

  const [{ data: irDriverData, loading: irDriverLoading, error: irDriverError}, getIrDriver] = useAxios({
    url: baseUrl + "/iracing_driver",
    method: "get",
    headers: axiosHeaders,
    params: {
      irUserName: name
    }
  }, { 
    manual: true,
  })


  const [{ data: leagueDriver, loading: leagueDriverLoading, error: leagueDriverError}, getLeagueDriver] = useAxios({
    url: baseUrl + "/league-driver",
    method: "get",
    headers: axiosHeaders,
    params: {
      method: "get",
      leagueId: leagueId,
      driverId: userAttributes["custom:leagueDriverId"],
    },
  }, {
    manual: false,
  });


  const [{ data: seriesDriver, loading: seriesDriverLoading, error: seriesDriverError}, getSeriesDriver] = useAxios({
    url: baseUrl + "/series-driver",
    method: "get",
    headers: axiosHeaders,
    params: {
      method: "get",
      leagueId: leagueId,
      seriesId: seriesId,
      driverId: userAttributes["custom:leagueDriverId"],
    },
  }, {
    manual: false,
  });



  const [{ data: updateLeagueDriver, loading: updateLeagueDriverLoading, error: updateLeagueDriverError}, postLeagueDriver] = useAxios({
    url: baseUrl + "/league-driver",
    method: "post",
    headers: axiosHeaders,
    data: {
      leagueId: leagueId,
      driverId: userAttributes["custom:leagueDriverId"],
      name: name,
      givenName: givenName,
      familyName: familyName,
      email: email,
      address: address,
      addressUrl: addressUrl,
      country: country,
      state: state,
      postCode: postCode,
      dob: dob,
      irUserId: Number(irUserId),
      irUserName: irUserName,
      // carNum: leagueCarNum? Number(leagueCarNum): undefined,
      // secondaryCarNum: leagueSecondaryCarNum? Number(leagueSecondaryCarNum): undefined,
      // tertiaryCarNum: leagueTertiaryCarNum? Number(leagueTertiaryCarNum): undefined,
      agreeToFrgPrivayPolicy: agreeToFrgPrivayPolicy,
    }
  }, {
    manual: true,
  });


  const [{ data: updateSeriesDriver, loading: updateSeriesDriverLoading, error: updateSeriesDriverError}, postSeriesDriver] = useAxios({
    url: baseUrl + "/series-driver",
    method: "post",
    headers: axiosHeaders,
    data: {
      leagueId: leagueId,
      seriesId: seriesId,
      driverId: driverId,
      irUserId: Number(irUserId),
      irUserName: irUserName,
      address: address,
      country: country,
      // carNum: Number(seriesCarNum) ? Number(seriesCarNum): undefined,
      // secondaryCarNum: Number(seriesSecondaryCarNum) ? Number(seriesSecondaryCarNum): undefined,
      // tertiaryCarNum: Number(seriesTertiaryCarNum) ? Number(seriesTertiaryCarNum): undefined,
      agreeToFrgPrivayPolicy: agreeToFrgPrivayPolicy,
      agreeToSeriesRules: agreeToSeriesRules,
    }
  }, {
    manual: true,
  });


  useEffect(() => {
    if (leagueDriver !== undefined) {
      // setUserAttributes(user.getSignInUserSession()!.getIdToken().payload)
      const username = userAttributes["cognito:username"]
      const groups = userAttributes["cognito:groups"]
      setDriverId(userAttributes["custom:leagueDriverId"])
      // setUsername(username);
      setEmail(userAttributes.email);
      setGivenName(leagueDriver.givenName);
      setFamilyName(leagueDriver.familyName);
      // setName(userAttributes.name);
      // setProfilePicture(userAttributes.picture);
      // setGroups(groups);
      setDob(leagueDriver.dob);
      // setPhone(leagueDriver.phone);
      // setAddressPlaceholder(leagueDriver.address);
      // setMaLicenseId(leagueDriver.maLicenseId);
      setIrUserId(Number(leagueDriver.irUserId));
      setIrUserName(leagueDriver.irUserName);
      // setDiscordId(leagueDriver.discordId);
      // setDriverBio(leagueDriver.driverBio);
      // setLeagueCarNum(leagueDriver.carNum);
      // setLeagueSecondaryCarNum(leagueDriver.secondaryCarNum);
      // setLeagueTertiaryCarNum(leagueDriver.tertiaryCarNum);
      setAgreeToFrgPrivayPolicy(Boolean(leagueDriver.agreeToFrgPrivayPolicy));
    }
  }, [leagueDriver]);

  useEffect(() => {
    if (seriesDriver !== undefined){
      setDriverRegistered(true)
      setCountry(seriesDriver.country)
      // setSeriesCarNum(seriesDriver.carNum);
      // setSeriesSecondaryCarNum(seriesDriver.secondaryCarNum);
      // setSeriesTertiaryCarNum(seriesDriver.tertiaryCarNum);
      setAgreeToSeriesRules(Boolean(seriesDriver.agreeToSeriesRules));
    }
  }, [seriesDriver])

  useEffect(() => {
    if (placeDetails !== undefined) {
      setAddressUrl(placeDetails.url)
      placeDetails.address_components.map( ( item:any ) => {
        if (item.types.includes("country")) setCountry(item.long_name);
        if (item.types.includes("postal_code")) setPostCode(item.long_name);
        if (item.types.includes("administrative_area_level_1")) setState(item.long_name); 
      })
    }
  }, [placeDetails]);


  const SubmitError = () => {
    if (submitError){
      return (
        <>
          <Alert
            statusIconAriaLabel="Error"
            type="error"
            header="All fields are mandatory"
            dismissible
            onDismiss={() => setSubmitError(false)}
          >
            All fields must be completed before you can submit your registration.
          </Alert>
        </>
      )
    } 
    return <></>
  }


  const RegistrationMessage = () => {
    if (driverRegistered) {
      return (
        <>
          <div style={{background: awsui.colorBackgroundNotificationGreen, color: "white", padding: "20px", borderRadius: "8px", marginBottom: "20px"}}>
            <div style={{display: "flex", fontSize: "28px", fontWeight: "bold", alignItems: "center", width: "100%", paddingBottom: "10px"}}>
              <div style={{width: "100%", textAlign: "left"}}>
              <center>You are registered for this series</center>
              </div>
            </div>
            <div style={{textAlign: "left", paddingBottom: "20px"}}>
              <p>You can edit your registration information below.</p>
              {/* <p>Additional information for the series will be available here closer to the date, including the hosted session access details and password.</p> */}
              <p>You can find out how to qualify&nbsp; 
                <a 
                  onClick={() => setSeriesContent("qualifying")}
                  style={{
                    color: "yellow"
                  }}
                >
                  here
                </a>.
              </p>
            </div>
            <br />
            <h5>Registered drivers from all nations can join the Motorsport Australia Discord</h5>
              <Link href="https://discord.gg/TmjrRCX7c7" target="_blank">
                <CustomButton
                  type="button"
                  onMouseEnter={ (event:any) => {
                    event.currentTarget.style.filter = `drop-shadow(1px 1px 3px #738ADB) hue-rotate(345deg)`;
                  }}
                  onMouseLeave={ (event:any) => {
                    event.currentTarget.style.filter = "none";
                  }}
                  style={{
                    background: "#738ADB",
                    color: "white",
                    maxWidth: "500px",
                  }}
                >
                  Discord Invite
                </CustomButton>
              </Link>
          </div>
        </>
      )
    }
    return (
     <>
        <div style={{display: "flex", fontSize: "28px", fontWeight: "bold", alignItems: "center", width: "100%", paddingBottom: "10px"}}>
          <div style={{width: "100%", textAlign: "left"}}>
            Series Registration
          </div>
        </div>
     </> 
    )
  }


  if (route !== 'authenticated') {
    navigate('/signin')
  }

  return (
    <>   
      <div style={{width: "100%", paddingTop: "50px", paddingBottom: "50px"}}>
        <div className="body-content">
          <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}> 
            { leagueDriverLoading || seriesDriverLoading || updateSeriesDriverLoading || leagueDriverLoading ? (
              <div style={{width: "100%", justifyContent: "center", alignItems: "center"}}>
                <RotatingLines
                  width="50%"
                  strokeWidth="10px"
                  strokeColor={awsui.colorBackgroundButtonPrimaryActive}
                  ariaLabel="loading-driver-profile"
                  key={"loader"}
                  visible={true}
                />
              </div>
            ) : (
              <>  
                <div style={{maxWidth: "800px"}}>
                  <RegistrationMessage />
                  <Form
                    actions={
                      <SpaceBetween direction="horizontal" size="xs" key={"SeriesRegistrationFormButtons"}>
                          <SubmitError />
                          <Button 
                            variant="primary"
                            formAction="submit"
                            key={"submit-registration-button"}
                            onClick={ async() => {
                              if (irUserId && irUserName && givenName && familyName && address && country && dob && agreeToFrgPrivayPolicy && agreeToSeriesRules ){
                                await postSeriesDriver();
                                await postLeagueDriver();
                                window.location.reload()
                              } else {
                                setSubmitError(true)
                              }
                            }}
                            loading={updateSeriesDriverLoading}
                          >
                            {driverRegistered ? "Update" : "Register"}
                          </Button>
                      </SpaceBetween>
                    }
                    key={"series-registration-form"}
                  >
                    <SpaceBetween size="xxl" direction="vertical" key={"SeriesRegistrationFormFields"}>
                      <Grid
                        gridDefinition={[
                          { colspan: { default: 12, xs: 12, } },
                          { colspan: { default: 12, xs: 6, } },
                          { colspan: { default: 12, xs: 6, } },
                          { colspan: { default: 12, xs: 8, } },
                          { colspan: { default: 12, xs: 4, } },
                          { colspan: { default: 12, xs: 12, } },
                        ]}
                        key={"personal-details-grid"}
                      >  
                        <FormField 
                          label="Email Address" 
                          stretch 
                        >
                          <Input
                            // onChange={({ detail }) => {setEmail(detail.value)}}
                            value={email ? email : ""}
                            disabled
                          />
                        </FormField>
                        <FormField label="First Name" stretch >
                          <Input
                            onChange={({ detail }) => {setGivenName(detail.value.substring(0, 20))}}
                            value={givenName ? givenName : ""}
                            // disabled
                          />
                        </FormField>
                        <FormField label="Last Name" stretch >
                          <Input
                            onChange={({ detail }) => {setFamilyName(detail.value.substring(0, 20))}}
                            value={familyName ? familyName : ""}
                          />
                        </FormField>
                        <FormField 
                          label="Address" 
                          stretch
                          description={driverRegistered ? "Re-enter your address when updating your registration details" : ""}  
                        >
                          <Autosuggest
                            onSelect={ ( { detail } ) => {
                              setAddress(detail.selectedOption?.description!)
                              getPlacePredictions({ input: detail.selectedOption?.description })
                            }}
                            onChange={ ( event ) => {
                              setAddress(event.detail.value.substring(0, 50));
                              getPlacePredictions({ input: event.detail.value });
                            }}
                            disableBrowserAutocorrect
                            placeholder={"Enter Address"}
                            value={address ? address : ""}
                            options={placePredictions.map((item) => (item))}
                            ariaLabel="Auto select address"
                            loadingText="Loading"
                            key={"autosuggest-address"}
                            statusType={isPlacePredictionsLoading ? "loading" : "finished"}
                            enteredTextLabel={()=>{return ""}}
                          />
                        </FormField>
                        <FormField 
                          label="Date of Birth"
                          stretch
                        >
                          <DatePicker id="date-picker"
                            name='Date of birth'
                            key={"dob-date-picker"}
                            onChange={ ( event ) => {
                              setDob(new Date(event.target.value).toLocaleDateString())
                            }}
                            placeholder={new Date(dob ? dob : "now").toLocaleDateString()}
                            value={new Date(dob ? dob : "now").toLocaleDateString()}
                          />  
                        </FormField>
                        <div data-country-radio-group style={{background: awsui.colorBackgroundButtonNormalActive, borderRadius: "8px", justifyContent: "center", alignItems: "center", padding: "10px" }}>
                          <FormField
                            label="Country"
                            stretch
                            key={"select-country"}
                            description="Select the country you'll be representing"
                          >
                              <RadioGroup data-country-radio-group
                                onChange={({ detail }) => setCountry(detail.value)}
                                value={country!}
                                key={"country-radio-group"}
                                items={[
                                  { value: "Australia", label: "Australia" },
                                  { value: "New Zealand", label: "New Zealand" },
                                  { value: "United Kingdom", label: "United Kingdom" }
                                ]}
                              />
                          </FormField>
                        </div>
                      </Grid>
                      <div style={{
                        borderRadius: "8px",
                        padding: "15px",
                        background: "#c8cef7",
                        marginTop: "10px",
                      }}>
                        <Grid
                          gridDefinition={[
                            { colspan: { default: 12, xs: 4, } },
                            { colspan: { default: 12, xs: 4, } },
                            // { colspan: { default: 12, xs: 4, } },
                          ]}
                          key={"irdriver-lookup-grid"}
                        >
                          <FormField label="iRacing User ID" stretch >
                            <Input
                              onChange={({ detail }) => {setIrUserId(Number(detail.value))}}
                              value={irUserId ? irUserId.toString() : ""}
                              // disabled
                            />
                          </FormField>
                          <FormField label="iRacing Driver Name" stretch>
                            <Input
                              onChange={({ detail }) => {setIrUserName(detail.value)}}
                              value={irUserName ? irUserName : ""}
                              // disabled
                            />
                          </FormField>
                        </Grid>
                      </div>
                      {/* <Grid
                        gridDefinition={[
                          { colspan: { default: 12, xs: 4, } },
                          { colspan: { default: 12, xs: 4, } },
                          { colspan: { default: 12, xs: 4, } },
                        ]}
                        key={"car-numbers-grid"}
                      >
                        <FormField label="Car # First Preference" >
                          <Input
                            onChange={({ detail }) => {setSeriesCarNum(detail.value.substring(0, 3))}}
                            type="number"
                            value={seriesCarNum ? seriesCarNum : leagueCarNum}
                          />
                        </FormField>
                        <FormField label="Car # Second Preference" stretch >
                          <Input
                            onChange={({ detail }) => {setSeriesSecondaryCarNum(detail.value.substring(0, 3))}}
                            type="number"
                            value={seriesSecondaryCarNum ? seriesSecondaryCarNum : leagueSecondaryCarNum}
                          />
                        </FormField>
                        <FormField label="Car # Third Preference" stretch>
                          <Input
                            onChange={({ detail }) => {setSeriesTertiaryCarNum(detail.value.substring(0, 3))}}
                            type="number"
                            value={seriesTertiaryCarNum ? seriesTertiaryCarNum : leagueTertiaryCarNum}
                          />
                        </FormField>
                      </Grid> */}
                      <Box>
                      <Checkbox
                          onChange={({ detail }) =>
                            setAgreeToSeriesRules(detail.checked)
                          }
                          checked={agreeToSeriesRules}
                          key={"checkbox-agree-to-rules"}
                        >
                          You have read and agree to the&nbsp;
                          <Link 
                            href=""
                            onFollow={ (event) => {
                              setSeriesContent("rules")
                            }}
                            fontSize="inherit"
                            key={"rules-link"}
                          >
                            FRG rules
                          </Link>
                          &nbsp;for the series
                        </Checkbox>
                        <Checkbox
                          onChange={({ detail }) =>
                            setAgreeToFrgPrivayPolicy(detail.checked)
                          }
                          checked={agreeToFrgPrivayPolicy}
                          key={"checkbox-agree-to-policy"}
                        >
                          You have read and agree to the&nbsp;
                          <Link
                            href="/about"
                            onFollow={ ( event ) => {
                              event.preventDefault();
                              navigate(event.detail.href!)
                            }}
                            fontSize="inherit"
                            key={"policy-link"}
                          >
                          FRG privacy policy
                          </Link>
                          
                        </Checkbox>
                      </Box>
                    </SpaceBetween>
                  </Form>
                  <div style={{marginTop: "40px"}}>
                    <p>Problems with your registration? &nbsp;
                      <Link
                        href="mailto:formularacinggroup@gmail.com"
                        target="_blank"
                        key={"email-frg-link"}
                        fontSize="inherit"
                      >
                      Contact FRG
                      </Link>
                    </p>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
